export default __webpack_public_path__ + "static/Zendesk-2901ed72caab191c6829630b4f331776.png";